import React, { useRef, useEffect } from 'react';
import { Typography, Spin, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import ChatMessage from './ChatMessage';
import StreamingMessage from './StreamingMessage';
import isEmpty from 'lodash/isEmpty'

const { Text } = Typography;

/**
 * ChatHistory - Chat messages container with auto-scroll
 *
 * @param {Object} props
 * @param {Array} props.messages - Array of message objects
 * @param {string} props.streamingContent - Content being streamed
 * @param {boolean} props.processing - Whether AI is processing
 */
export default function ChatHistory(props) {
  const { messages, streamingContent, processing } = props
  const { t } = useTranslation();
  const containerRef = useRef(null);

  // Auto scroll to bottom
  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [messages, streamingContent]);
  return (
    <div
      ref={containerRef}
      style={{
        flex: 1,
        minWidth: 0,
        overflowY: 'auto',
        overflowX: 'hidden',
        padding: '24px 28px 16px',
        backgroundColor: '#fafaf8'
      }}
    >
      {messages.map((msg, idx) => (
        <ChatMessage key={msg.id || idx} message={msg} />
      ))}

      {/* Streaming message */}
      <StreamingMessage content={streamingContent} />

      {/* Loading indicator — only before first streaming content arrives */}
      {processing && isEmpty(streamingContent) && (
        <div style={{ textAlign: 'center', padding: '16px' }}>
          <Space>
            <Spin size="small" />
            <Text type="secondary">{t('operator.ai_chat.thinking', 'AI is thinking...')}</Text>
          </Space>
        </div>
      )}
    </div>
  );
}
